import React from "react";
const TextArea = (props) => {
  let classes = "form-control form-control-lg theme-form-control";
  if (props.className) {
    classes = `${classes} ${props.className}`;
  }
  if (props.error) {
    classes = `${classes} theme-error-input`;
  }

  return (
    <textarea
      min={props.min}
      max={props.max}
      autoComplete="off"
      type="text"
      {...props.formControl}
      className={classes}
    />
  );
};

export default TextArea;
